const $41f4f3a0039fd884$var$initTilt = ()=>{
    // Projects images
    $(".project-wrapper__image a div").tilt({
        maxTilt: 3
    });
};
var $41f4f3a0039fd884$export$2e2bcd8739ae039 = $41f4f3a0039fd884$var$initTilt;


function $1e73e9e5c54c6c4c$export$2e2bcd8739ae039(props, defaultProps) {
    // Fix for SCRIPT1028 in Edge
    return Object.assign({}, defaultProps, props);
}


function $79126358936b1f75$export$2e2bcd8739ae039() {
    const defaultProps = {
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        distance: "30px",
        duration: 1000,
        desktop: true,
        mobile: true
    };
    /* Section Title */ ScrollReveal().reveal(".section-title", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 300,
        distance: "0px",
        origin: "bottom"
    }, defaultProps));
    /* Hero Section */ ScrollReveal().reveal(".hero-title", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 500,
        origin: window.innerWidth > 768 ? "left" : "bottom"
    }, defaultProps));
    ScrollReveal().reveal(".hero-cta", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 1000,
        origin: window.innerWidth > 768 ? "left" : "bottom"
    }, defaultProps));
    /* About Section */ ScrollReveal().reveal(".about-wrapper__image", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 600,
        origin: "bottom"
    }, defaultProps));
    ScrollReveal().reveal(".about-wrapper__info", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 1000,
        origin: window.innerWidth > 768 ? "left" : "bottom"
    }, defaultProps));
    /* Projects Section */ ScrollReveal().reveal(".project-wrapper__text", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 500,
        origin: window.innerWidth > 768 ? "left" : "bottom"
    }, defaultProps));
    ScrollReveal().reveal(".project-wrapper__image", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 1000,
        origin: window.innerWidth > 768 ? "right" : "bottom"
    }, defaultProps));
    /* Contact Section */ ScrollReveal().reveal(".contact-wrapper", (0, $1e73e9e5c54c6c4c$export$2e2bcd8739ae039)({
        delay: 800,
        origin: "bottom"
    }, defaultProps));
}



$('a[href^="#"]').on("click", function(event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
        event.preventDefault();
        $("html, body").stop().animate({
            scrollTop: target.offset().top
        }, 1000);
    }
});
function $35da740d59af89ba$var$addResume(pdf) {
    if (!pdf) return;
    const resumeButton = document.querySelector(".cta-btn--resume");
    resumeButton.setAttribute("href", pdf);
}
function $35da740d59af89ba$var$detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return toMatch.some((toMatchItem)=>{
        return navigator.userAgent.match(toMatchItem);
    });
}
$35da740d59af89ba$var$detectMob() == false ? ScrollTrigger.create({
    animation: gsap.from(".logo", {
        y: "50vh",
        scale: 6,
        yPercent: -50,
        color: "#2e008b",
        background: "white"
    }),
    scrub: true,
    trigger: "#hero",
    start: "top bottom",
    endTrigger: "#hero",
    end: "top center"
}) : ScrollTrigger.create({
    animation: gsap.from(".logo", {
        y: "50vh",
        scale: 3,
        yPercent: -50,
        color: "#2e008b",
        background: "white"
    }),
    scrub: true,
    trigger: "#hero",
    start: "top bottom",
    endTrigger: "#hero",
    end: "top center"
});
const $35da740d59af89ba$var$imgs = document.querySelectorAll(".img-fluid");
const $35da740d59af89ba$var$observer = lozad($35da740d59af89ba$var$imgs);
$35da740d59af89ba$var$observer.observe();
(0, $79126358936b1f75$export$2e2bcd8739ae039)();
(0, $41f4f3a0039fd884$export$2e2bcd8739ae039)();
let $35da740d59af89ba$var$link = "https://mail.google.com/mail/?view=cm&fs=1&to=npiyush35@gmail.com&su=SUBJECT&body=BODY";
console.log("Contact Me :" + $35da740d59af89ba$var$link);
let $35da740d59af89ba$var$year = new Date();
$(".footer__text").html(`Customize by
<a href="https://github.com/npiyush97 " target="_blank" aria-label="Link to github"
  >Piyush Negi
</a>
© ${$35da740d59af89ba$var$year.getFullYear()} - Template developed by<br />
<a href="https://github.com/cobidev" target="_blank"
  >Jacobo Martínez</a
>`);


//# sourceMappingURL=index.61b53b67.js.map
